export enum LegalForm {
    AG = 'LEGAL_FORM_AG', // AG (Kapitalgesellschaft)
    AG_CO_KG = 'LEGAL_FORM_AG_CO_KG', // AG Co KG (Kapitalgesellschaft)
    AG_CO_OHG = 'LEGAL_FORM_AG_CO_OHG', // AG Co OHG (Kapitalgesellschaft)
    AUSLAENDISCHE_RECHTSFORM = 'LEGAL_FORM_AUSLAENDISCHE_RECHTSFORM', // ausländische Rechtsform
    AOK = 'LEGAL_FORM_ANSTALT_UND_KÖRPERSCHSFT_ÖFFENTLICHEN_RECHTS',
    BUND_LAENDER_BEHOERDEN = 'LEGAL_FORM_BUND_LAENDER_BEHOERDEN', // Bund, Laender, Behoerden
    EINGETRAGENE_GENOSSENSCHAFT = 'LEGAL_FORM_EINGETRAGENE_GENOSSENSCHAFT', // eingetragene Genossenschaft (eG)
    EINGETRAGENER_KAUFMANN = 'LEGAL_FORM_EINGETRAGENER_KAUFMANN', // eingetragener Kaufmann (e.K.) (Personengesellschaft)
    EINGETRAGENER_VEREIN = 'LEGAL_FORM_EINGETRAGENER_VEREIN', // eingetragener Verein (e.V.)
    FREIE_BERUFE = 'LEGAL_FORM_FREIE_BERUFE', // Freie Berufe (Personengesellschaft)
    GESELLSCHAFT_BUERGERLICHEN_RECHTS = 'LEGAL_FORM_GESELLSCHAFT_BUERGERLICHEN_RECHTS', // Gesellschaft bürgerlichen Rechts (GbR) (Personengesellschaft)
    GEWERBEBETRIEB = 'LEGAL_FORM_GEWERBEBETRIEB', // Gewerbebetrieb
    GMBH = 'LEGAL_FORM_GMBH', // GmbH (Kapitalgesellschaft)
    GMBH_CO = 'LEGAL_FORM_GMBH_CO', // GmbH Co (Kapitalgesellschaft)
    GMBH_CO_KG = 'LEGAL_FORM_GMBH_CO_KG', // GmbH Co KG (Kapitalgesellschaft)
    GMBH_CO_KG_AA = 'LEGAL_FORM_GMBH_CO_KG_AA', // GmbH Co KG Aa (Kapitalgesellschaft)
    GMBH_CO_KG_OHG = 'LEGAL_FORM_GMBH_CO_KG_OHG', // GmbH Co KG OHG (Kapitalgesellschaft)
    KG = 'LEGAL_FORM_KG', // KG * (Personengesellschaft)
    KGAA = 'LEGAL_FORM_KGAA', // KGaA (Kommanditgesellschaft auf Aktien) (Kapitalgesellschaft)
    OHG = 'LEGAL_FORM_OHG', // OHG (Personengesellschaft)
    PARTNERSCHAFTSGESELLSCHAFT = 'LEGAL_FORM_PARTNERSCHAFTSGESELLSCHAFT', // Partnerschaftsgesellschaft (Personengesellschaft)
    SONSTIGE_RECHTSFORM = 'LEGAL_FORM_SONSTIGE_RECHTSFORM', // sonstige Rechtsform
    STIFTUNG = 'LEGAL_FORM_STIFTUNG', // Stiftung
    UG = 'LEGAL_FORM_UG', // UG (haftungsbeschränkt) (Kapitalgesellschaft)
    VVAG = 'LEGAL_FORM_VVAG', // VVaG (Versicherungsverein auf Gegenseitigkeit)
}

export enum CompanyType {
    UNSPECIFIED = 'COMPANY_TYPE_UNSPECIFIED',
    PRIVATE = 'COMPANY_TYPE_PRIVATE',
    CAPITAL = 'COMPANY_TYPE_CAPITAL',
}

export type LegalFormEntry = {
    value: string;
    type: CompanyType;
    key: LegalForm;
    label: string;
};

export const LegalFormLookup: Record<LegalForm, LegalFormEntry> = {
    [LegalForm.AG]: {
        value: 'LEGAL_FORM_AG',
        type: CompanyType.CAPITAL,
        key: LegalForm.AG,
        label: 'AG',
    },
    [LegalForm.AG_CO_KG]: {
        value: 'LEGAL_FORM_AG_CO_KG',
        type: CompanyType.CAPITAL,
        key: LegalForm.AG_CO_KG,
        label: 'AG Co KG',
    },
    [LegalForm.AG_CO_OHG]: {
        value: 'LEGAL_FORM_AG_CO_OHG',
        type: CompanyType.CAPITAL,
        key: LegalForm.AG_CO_OHG,
        label: 'AG Co OHG',
    },
    [LegalForm.AUSLAENDISCHE_RECHTSFORM]: {
        value: 'LEGAL_FORM_AUSLAENDISCHE_RECHTSFORM',
        type: CompanyType.UNSPECIFIED,
        key: LegalForm.AUSLAENDISCHE_RECHTSFORM,
        label: 'ausländische Rechtsform',
    },
    [LegalForm.AOK]: {
        value: 'LEGAL_FORM_ANSTALT_UND_KÖRPERSCHSFT_ÖFFENTLICHEN_RECHTS',
        type: CompanyType.UNSPECIFIED,
        key: LegalForm.AUSLAENDISCHE_RECHTSFORM,
        label: 'Anstalt und Körperschaft Öffentlichen Rechts',
    },
    [LegalForm.BUND_LAENDER_BEHOERDEN]: {
        value: 'LEGAL_FORM_BUND_LAENDER_BEHOERDEN',
        type: CompanyType.UNSPECIFIED,
        key: LegalForm.BUND_LAENDER_BEHOERDEN,
        label: 'Bund, Länder, Behörden',
    },
    [LegalForm.EINGETRAGENE_GENOSSENSCHAFT]: {
        value: 'LEGAL_FORM_EINGETRAGENE_GENOSSENSCHAFT',
        type: CompanyType.UNSPECIFIED,
        key: LegalForm.EINGETRAGENE_GENOSSENSCHAFT,
        label: 'eingetragene Genossenschaft (e.G.)',
    },
    [LegalForm.EINGETRAGENER_KAUFMANN]: {
        value: 'LEGAL_FORM_EINGETRAGENER_KAUFMANN',
        type: CompanyType.PRIVATE,
        key: LegalForm.EINGETRAGENER_KAUFMANN,
        label: 'eingetragener Kaufmann (e.K.)',
    },
    [LegalForm.EINGETRAGENER_VEREIN]: {
        value: 'LEGAL_FORM_EINGETRAGENER_VEREIN',
        type: CompanyType.UNSPECIFIED,
        key: LegalForm.EINGETRAGENER_VEREIN,
        label: 'eingetragener Verein (e.V.)',
    },
    [LegalForm.FREIE_BERUFE]: {
        value: 'LEGAL_FORM_FREIE_BERUFE',
        type: CompanyType.PRIVATE,
        key: LegalForm.FREIE_BERUFE,
        label: 'Freie Berufe',
    },
    [LegalForm.GESELLSCHAFT_BUERGERLICHEN_RECHTS]: {
        value: 'LEGAL_FORM_GESELLSCHAFT_BUERGERLICHEN_RECHTS',
        type: CompanyType.PRIVATE,
        key: LegalForm.GESELLSCHAFT_BUERGERLICHEN_RECHTS,
        label: 'Gesellschaft bürgerlichen Rechts (GbR)',
    },
    [LegalForm.GEWERBEBETRIEB]: {
        value: 'LEGAL_FORM_GEWERBEBETRIEB',
        type: CompanyType.UNSPECIFIED,
        key: LegalForm.GEWERBEBETRIEB,
        label: 'Gewerbebetrieb',
    },
    [LegalForm.GMBH]: {
        value: 'LEGAL_FORM_GMBH',
        type: CompanyType.CAPITAL,
        key: LegalForm.GMBH,
        label: 'GmbH',
    },
    [LegalForm.GMBH_CO]: {
        value: 'LEGAL_FORM_GMBH_CO',
        type: CompanyType.CAPITAL,
        key: LegalForm.GMBH_CO,
        label: 'GmbH Co',
    },
    [LegalForm.GMBH_CO_KG]: {
        value: 'LEGAL_FORM_GMBH_CO_KG',
        type: CompanyType.CAPITAL,
        key: LegalForm.GMBH_CO_KG,
        label: 'GmbH Co KG',
    },
    [LegalForm.GMBH_CO_KG_AA]: {
        value: 'LEGAL_FORM_GMBH_CO_KG_AA',
        type: CompanyType.CAPITAL,
        key: LegalForm.GMBH_CO_KG_AA,
        label: 'GmbH Co KG Aa',
    },
    [LegalForm.GMBH_CO_KG_OHG]: {
        value: 'LEGAL_FORM_GMBH_CO_KG_OHG',
        type: CompanyType.CAPITAL,
        key: LegalForm.GMBH_CO_KG_OHG,
        label: 'GmbH Co KG OHG',
    },
    [LegalForm.KG]: {
        value: 'LEGAL_FORM_KG',
        type: CompanyType.PRIVATE,
        key: LegalForm.KG,
        label: 'KG *',
    },
    [LegalForm.KGAA]: {
        value: 'LEGAL_FORM_KGAA',
        type: CompanyType.CAPITAL,
        key: LegalForm.KGAA,
        label: 'KGaA (Kommanditgesellschaft auf Aktien)',
    },
    [LegalForm.OHG]: {
        value: 'LEGAL_FORM_OHG',
        type: CompanyType.PRIVATE,
        key: LegalForm.OHG,
        label: 'OHG',
    },
    [LegalForm.PARTNERSCHAFTSGESELLSCHAFT]: {
        value: 'LEGAL_FORM_PARTNERSCHAFTSGESELLSCHAFT',
        type: CompanyType.PRIVATE,
        key: LegalForm.PARTNERSCHAFTSGESELLSCHAFT,
        label: 'Partnerschaftsgesellschaft',
    },
    [LegalForm.SONSTIGE_RECHTSFORM]: {
        value: 'LEGAL_FORM_SONSTIGE_RECHTSFORM',
        type: CompanyType.UNSPECIFIED,
        key: LegalForm.SONSTIGE_RECHTSFORM,
        label: 'sonstige Rechtsform',
    },
    [LegalForm.STIFTUNG]: {
        value: 'LEGAL_FORM_STIFTUNG',
        type: CompanyType.UNSPECIFIED,
        key: LegalForm.STIFTUNG,
        label: 'Stiftung',
    },
    [LegalForm.UG]: {
        value: 'LEGAL_FORM_UG',
        type: CompanyType.CAPITAL,
        key: LegalForm.UG,
        label: 'UG (haftungsbeschränkt)',
    },
    [LegalForm.VVAG]: {
        value: 'LEGAL_FORM_VVAG',
        type: CompanyType.UNSPECIFIED,
        key: LegalForm.VVAG,
        label: 'VVaG (Versicherungsverein auf Gegenseitigkeit)',
    },
};
